<div class="load-pdf-button">
  <ng-container *ngIf="fileUrl; else uploadButton">
    <div class="upload-file-wrapper">
      <div class="information-about-file">
        <mat-icon svgIcon="file"></mat-icon>
        <span class="file-name">{{ fileName ? fileName : 'File loaded' }}</span>
      </div>

      <div class="controls">
        <a [href]="fileUrl" target="_blank" rel="noopener">
          <mat-icon class="preview">visibility</mat-icon>
        </a>
        <mat-icon *ngIf="!hideRemoveAction" class="cancel" (click)="cancel()">close</mat-icon>
      </div>
    </div>
  </ng-container>

  <ng-template #uploadButton>
    <button class="upload-button" mat-stroked-button (click)="onClick(fileInput)" color="primary">
      <mat-spinner *ngIf="isLoading; else buttonAddText" [diameter]="24"></mat-spinner>

      <ng-template #buttonAddText>
        <mat-icon>add</mat-icon>
        {{ buttonText }}
      </ng-template>
    </button>
  </ng-template>

  <input #fileInput class="upload-input" type="file" (change)="onFileSelected($event)">
</div>
